import React, { memo } from 'react';
import { BottomSheetType, } from '@voltmoney/schema';
import { BottomSheetBase } from './bottomSheet.base';
import { BottomSheetWebBase } from './bottomSheetWeb.base';
const BottomSheet = ({ ...props }) => {
    const type = props.type;
    switch (type) {
        case BottomSheetType.MOBILE:
            return React.createElement(BottomSheetBase, { ...props });
        case BottomSheetType.WEB:
            return React.createElement(BottomSheetWebBase, { ...props });
        default:
            return React.createElement(BottomSheetBase, { ...props });
    }
};
export default memo(BottomSheet);
export { BottomSheet };
